import {
  messageReviewReasonCodesLabel,
  messageTypeLabel,
} from '../utils/messageReviewLabels';

type MessageRiskReasonsProps = {
  serviceFailure?: boolean;
  reasonCodes?: string[] | null;
  recipientMatches?: boolean;
  bodyMatches?: boolean;
  messagesScreen?: boolean;
  blueIMessageDetected?: boolean;
  redactedSummary?: Record<string, unknown> | null;
};

function yesNo(value: boolean | undefined): string {
  if (value === true) return '是';
  if (value === false) return '否';
  return '-';
}

export function MessageRiskReasons({
  serviceFailure,
  reasonCodes,
  recipientMatches,
  bodyMatches,
  messagesScreen,
  blueIMessageDetected,
  redactedSummary,
}: MessageRiskReasonsProps) {
  const codes = (reasonCodes ?? []).filter(Boolean);

  return (
    <section className="space-y-3">
      <h3 className="text-base font-medium text-gray-900">风险理由</h3>
      <div className="rounded-md border border-gray-200 px-4">
        <Row label="收件人匹配" value={serviceFailure ? '未完成识别' : yesNo(recipientMatches)} />
        <Row label="正文匹配" value={serviceFailure ? '未完成识别' : yesNo(bodyMatches)} />
        <Row label="Messages 在屏" value={serviceFailure ? '未完成识别' : yesNo(messagesScreen)} />
        <Row label="短信类型" value={messageTypeLabel(blueIMessageDetected, reasonCodes)} />
        <Row
          label="具体原因"
          value={messageReviewReasonCodesLabel(codes)}
        />
        <Row
          label="脱敏摘要"
          value={redactedSummary ? JSON.stringify(redactedSummary) : '-'}
          mono
        />
      </div>
    </section>
  );
}

function Row({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="flex items-start py-2 border-b border-gray-100 last:border-b-0">
      <span className="w-28 shrink-0 text-xs text-gray-500">{label}</span>
      <span className={`min-w-0 text-sm text-gray-900 break-words ${mono ? 'font-mono text-xs' : ''}`}>{value}</span>
    </div>
  );
}
